import MigrationSetupContainer from './migration.setup.container'

export default MigrationSetupContainer
